export default "__VITE_ASSET__DvWrSY1A__"